var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 19.6875H15.0312V17.8125H4.96875V19.6875ZM4.96875 14.375H15.0312V12.5H4.96875V14.375ZM1.875 25C1.375 25 0.9375 24.8125 0.5625 24.4375C0.1875 24.0625 0 23.625 0 23.125V1.875C0 1.375 0.1875 0.9375 0.5625 0.5625C0.9375 0.1875 1.375 0 1.875 0H13.1562L20 6.84375V23.125C20 23.625 19.8125 24.0625 19.4375 24.4375C19.0625 24.8125 18.625 25 18.125 25H1.875ZM12.2188 7.6875V1.875H1.875V23.125H18.125V7.6875H12.2188Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.5a86478acbbf3c0725a75e367b0b645a.svg";
export { ForwardRef as ReactComponent };